import React from 'react';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import TableChartIcon from '@mui/icons-material/TableChart';
import TimelineIcon from '@mui/icons-material/Timeline';
import BarChartIcon from '@mui/icons-material/BarChart';
import PieChartIcon from '@mui/icons-material/PieChart';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import DataObjectIcon from '@mui/icons-material/DataObject';
import StorageIcon from '@mui/icons-material/Storage';
import CloudIcon from '@mui/icons-material/Cloud';
import SpeedIcon from '@mui/icons-material/Speed';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import BubbleChartIcon from '@mui/icons-material/BubbleChart';
import MultilineChartIcon from '@mui/icons-material/MultilineChart';
import StackedLineChartIcon from '@mui/icons-material/StackedLineChart';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import DonutSmallIcon from '@mui/icons-material/DonutSmall';
import ViewComfyIcon from '@mui/icons-material/ViewComfy';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewQuiltIcon from '@mui/icons-material/ViewQuilt';
import GridViewIcon from '@mui/icons-material/GridView';
import TableViewIcon from '@mui/icons-material/TableView';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';

const iconMap = {
  'LibraryBooks': LibraryBooksIcon,
  'Dashboard': DashboardIcon,
  'Analytics': AnalyticsIcon,
  'Assessment': AssessmentIcon,
  'ShowChart': ShowChartIcon,
  'TableChart': TableChartIcon,
  'Timeline': TimelineIcon,
  'BarChart': BarChartIcon,
  'PieChart': PieChartIcon,
  'InsertChart': InsertChartIcon,
  'DataObject': DataObjectIcon,
  'Storage': StorageIcon,
  'Cloud': CloudIcon,
  'Speed': SpeedIcon,
  'TrendingUp': TrendingUpIcon,
  'TrendingDown': TrendingDownIcon,
  'CompareArrows': CompareArrowsIcon,
  'ScatterPlot': ScatterPlotIcon,
  'BubbleChart': BubbleChartIcon,
  'MultilineChart': MultilineChartIcon,
  'StackedLineChart': StackedLineChartIcon,
  'DonutLarge': DonutLargeIcon,
  'DonutSmall': DonutSmallIcon,
  'ViewComfy': ViewComfyIcon,
  'ViewModule': ViewModuleIcon,
  'ViewQuilt': ViewQuiltIcon,
  'GridView': GridViewIcon,
  'TableView': TableViewIcon,
  'ViewList': ViewListIcon,
  'ViewWeek': ViewWeekIcon
};

export const getDashboardIcon = (iconName) => {
  const IconComponent = iconMap[iconName] || LibraryBooksIcon;
  return <IconComponent />;
};

export const getAvailableIcons = () => {
  return Object.keys(iconMap);
};

export default getDashboardIcon; 